import OrderHistories from '../../../components/pages/mypages/OrderHistories.vue'
export default {
  components: { OrderHistories }
}
